module.exports = __webpack_public_path__ + "static/img/IMG_20150308_180446.cedb613d.jpg";